/**
 * NSS - New Cart 09.02.26 | cross-sell carousel height fix.
 *
 * Rebuy's cross-sell carousel is Flickity, which measures the cells once and
 * gives .flickity-viewport a fixed height. If a card grows after that measure
 * (font swap, subtitle rendered from metafields, image load, longer copy) the
 * viewport keeps the old height and clips the bottom of the card.
 *
 * Fix: watch the cards with a ResizeObserver and, whenever one ends up taller
 * than its viewport, ask Rebuy/Flickity to re-measure (they listen to window
 * resize). Scoped to the new cart through .nss-cart-v2-marker so the live cart
 * is untouched. No-op on browsers without ResizeObserver / :has().
 */
(function () {
    if (!('ResizeObserver' in window) || !('MutationObserver' in window)) return;

    var BLOCK_SELECTOR =
        '.rebuy-cart:has(.nss-cart-v2-marker) [data-rebuy-component="cross-sell-widget"] .rebuy-product-block';

    var scheduled = false;
    function remeasure() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
            scheduled = false;
            window.dispatchEvent(new Event('resize'));
        });
    }

    var resizeObserver = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
            var block = entries[i].target;
            var viewport = block.closest('.flickity-viewport');
            if (!viewport) continue;
            if (block.getBoundingClientRect().height > viewport.getBoundingClientRect().height + 1) {
                remeasure();
                return;
            }
        }
    });

    var observed = new WeakSet();
    function observeBlocks() {
        var blocks;
        try {
            blocks = document.querySelectorAll(BLOCK_SELECTOR);
        } catch (e) {
            return; // :has() not supported
        }
        blocks.forEach(function (block) {
            if (observed.has(block)) return;
            observed.add(block);
            resizeObserver.observe(block);
        });
    }

    // The cart is rendered by Vue after load and re-rendered on every change,
    // so pick up new cards as they appear (one pass per animation frame).
    var pending = false;
    var mutationObserver = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
            pending = false;
            observeBlocks();
        });
    });

    function start() {
        observeBlocks();
        mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
})();
